import React from "react"
import Level from "./Level"
import { getLevels, setOrderLevels } from "./utils/evaluationLevel"

interface IProps {
  evaluation_level?: "conventional" | "modern" | "numeric" | "version_one" | "version_two" | "version_three" | object | undefined
  x?: number
  y?: number
  width?: number
  height?: number
}

const Levels = ({ evaluation_level = "conventional", x = 1080, y = 0, width = 839, height = 470 }: IProps): React.JSX.Element => {
  const levels = getLevels(evaluation_level)
  const orderedLevels = setOrderLevels(levels)

  const sortedKeys = Object.keys(orderedLevels)
  const levelWidth = width / sortedKeys.length

  const render = () => {
    return sortedKeys.map((level: any, index: number) => (
      <Level key={level} level={level} width={levelWidth} xPosition={x + (levelWidth * index)} label={orderedLevels[level] as string} />
    ))
  }

  return (
    <>
      {render()}
    </>
  )
}

export default Levels
